
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full Name List of "Vishnu" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full Name List of "Vishnu" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'भगवान विष्णु के 108 नाम, 108 Names Of Lord Vishnu, विष्णु जी 108 नामावली, विष्णु 108 नामावली, 108 names of Vishnu, Vishnu Namavali in Sanskrit, Vishnu Namavali with meanings'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'भगवान विष्णु के 108 नाम, 108 Names Of Lord Vishnu, विष्णु जी 108 नामावली, विष्णु 108 नामावली, 108 names of Vishnu, Vishnu Namavali in Sanskrit, Vishnu Namavali with meanings, Lord Vishnu names chanting, Vishnu names for puja, Vishnu Namavali stotra, 108 names of Lord Vishnu list'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/namavali/vishnu.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/namavali/vishnu.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Vishnu 108 Namavali | 108 Namavali -  विष्णु 108 नामावली (108 नामावली)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/namavali/vishnu"
        },
        "headline": "Vishnu 108 Namavali - विष्णु 108 नामावली(108 नामावली)",
        "name" : "Vishnu 108 Namavali - 108 Namavali",
        "description": "Explore the full Name List of 'Vishnu' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/namavali/vishnu.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  